// 引入样式
import './client/styles';
// 异步引入入口
async function loadMdfResource () {
  await import ('@mdf/cube/lib/cube.web')
  await import ('./client/mdf');
  if (cb.context.global.isMultilingualFlag() !== false) {
    await import ('@mdf/cube/lib/cb.intlMsg')
  }
  if (cb.rest.isEncrypt()) {
    await import ('@mdf/cube/lib/cb.crypto')
  }
  executeCbResourceReady();
}

// 解决单独打开页面偶尔白屏问题
const executeCbResourceReady = function () {
  // 工作台不需要走这个方法
  if (window.__DIWORK_INTEGRATION_MODE__ !== 'iframe') return;
  if (window.cbResourceReady && window.cb) {
    window.cbResourceReady();
  } else {
    setTimeout(() => {
      executeCbResourceReady.apply();
    }, 100);
  }
}

// 解决专属化chunk域名不对问题
if (!process.env.DISABLE_SENTRY) {
  // 设置 webpack 懒加载及大图片加载时的 public path
  if (window.__MDF_PUBLIC_PATH__) {
    // 这个变量从Node端设置，一般根据 indexJs 的路径设置相对路径。详情见 getMdfResource 相关逻辑
    __webpack_public_path__ = window.__MDF_PUBLIC_PATH__ // NOSONAR
  } else if (window._baseUrl) {
    __webpack_public_path__ = window._baseUrl + '/'; // eslint-disable-line
  }
}

loadMdfResource();
